// Visita vinda da app iOS (link enviado pelo assistente de apoio no
// WhatsApp, página /app/pagar). Guardado em localStorage — sobrevive ao
// login e à página estática do PayPal (public/paypal.html lê a mesma chave).
const KEY = 'GUGLA_FROM_APP'
const MAX_AGE_MS = 24 * 60 * 60 * 1000

export const APP_RETURN_TEXT =
  'Volte à app Gugla: o acesso é atualizado automaticamente.'

export function markFromApp() {
  try {
    localStorage.setItem(KEY, String(Date.now()))
  } catch (e) {
    // modo privado / armazenamento bloqueado: segue sem a nota
  }
}

export function isFromApp() {
  try {
    const ts = parseInt(localStorage.getItem(KEY) || '', 10)
    return !isNaN(ts) && Date.now() - ts < MAX_AGE_MS
  } catch (e) {
    return false
  }
}

/** Texto de sucesso do pagamento, com a indicação de voltar à app. */
export function paymentSuccessText(base) {
  return isFromApp() ? `${base} ${APP_RETURN_TEXT}` : base
}
